if (!customElements.get('moodtwist-notes')) {
  customElements.define('moodtwist-notes', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.mt-notes-toggle');
      this.layers = Array.from(this.querySelectorAll('.mt-noten-grid'));
      if (!this.button || !this.layers.length) return;
      this.expanded = false;
      this.desktop = window.matchMedia('(min-width: 900px)');
      this.onToggle = () => {
        this.expanded = !this.expanded;
        this.update();
        if (!this.expanded) this.button.scrollIntoView({ block: 'nearest' });
      };
      this.onBreakpoint = () => this.update();
      this.button.addEventListener('click', this.onToggle);
      this.desktop.addEventListener('change', this.onBreakpoint);
      this.update();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onToggle);
      this.desktop?.removeEventListener('change', this.onBreakpoint);
    }

    update() {
      const limit = this.desktop.matches ? 4 : 3;
      const hasMore = this.layers.some(layer => layer.children.length > limit);
      this.button.hidden = !hasMore;
      this.button.setAttribute('aria-expanded', String(hasMore && this.expanded));
      this.button.textContent = this.expanded ? this.button.dataset.hideLabel : this.button.dataset.showLabel;
      this.layers.forEach(layer => {
        Array.from(layer.children).forEach((note, index) => {
          const hide = !this.expanded && index >= limit;
          if (hide && note.contains(document.activeElement)) this.button.focus({ preventScroll: true });
          note.hidden = hide;
        });
      });
    }
  });
}
